module.exports = __webpack_public_path__ + "static/img/BrechtGeorge_lettertoJillJohnston_2_c1963.3ecc48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brecht/archive/BrechtGeorge_lettertoJillJohnston_2_c1963.jpg
// module id = Tt5l
// module chunks = 0